import { c as _c } from "react/compiler-runtime";
import type { TrackedWord } from '@/app/[locale]/(vocabulary)/_lib/LexiconTrie';
import { LEARNING_PHASE } from '@/app/[locale]/(vocabulary)/_lib/LexiconTrie';
import { cn } from '@/lib/utils';
export function VocabToggle(t0) {
  const $ = _c(30);
  const {
    vocab,
    onToggle,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const phase = vocab.learningPhase;
  const {
    NEW,
    RETAINING,
    ACQUAINTED,
    FADING
  } = LEARNING_PHASE;
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex w-[calc(28px+.1px)] justify-center", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = phase === RETAINING || phase === FADING;
  const t4 = phase === NEW && "border-zinc-300 bg-transparent text-transparent dark:border-zinc-600";
  const t5 = phase === RETAINING && "border-zinc-200/80 bg-amber-300/60 text-white duration-300 dark:border-zinc-600 dark:bg-amber-300/60 dark:text-black/60";
  const t6 = phase === ACQUAINTED && "border-amber-300 bg-amber-300 text-transparent hover:bg-amber-300/80 dark:hover:bg-amber-300/80";
  const t7 = phase === FADING && "border-amber-300/80 bg-amber-300/15 text-amber-400 dark:border-amber-300/60 dark:bg-amber-300/10 dark:text-amber-300/60";
  let t8;
  if ($[2] !== className || $[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7) {
    t8 = cn("group/tgl inline-flex size-6 max-h-full grow-0 items-center justify-center rounded-full border p-1.25 text-center align-middle text-xs/3 whitespace-nowrap transition-colors not-disabled:cursor-pointer not-disabled:active:scale-95", t4, t5, t6, t7, className);
    $[2] = className;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onToggle || $[9] !== vocab) {
    t9 = () => {
      onToggle(vocab);
    };
    $[8] = onToggle;
    $[9] = vocab;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = phase === RETAINING || phase === FADING ? "" : "hidden";
  let t11;
  if ($[11] !== t10) {
    t11 = cn("icon-[lucide--loader] inline-flex w-full animate-spin items-center justify-center transition-colors duration-1000 [animation-duration:2s]", t10);
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = <svg className={t11} />;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = phase === NEW || phase === ACQUAINTED ? "" : "hidden";
  const t14 = phase === NEW && "text-transparent transition-colors duration-200 group-hover/tgl:text-black dark:group-hover/tgl:text-zinc-400";
  const t15 = phase === ACQUAINTED && "text-white dark:text-black";
  let t16;
  if ($[15] !== t13 || $[16] !== t14 || $[17] !== t15) {
    t16 = cn("icon-[lucide--check] inline-flex w-full items-center justify-center", t13, t14, t15);
    $[15] = t13;
    $[16] = t14;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  let t17;
  if ($[19] !== t16) {
    t17 = <svg className={t16} />;
    $[19] = t16;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t12 || $[22] !== t17 || $[23] !== t3 || $[24] !== t8 || $[25] !== t9) {
    t18 = <button type="button" aria-label="Toggle vocabulary state" disabled={t3} className={t8} onClick={t9}>{t12}{t17}</button>;
    $[21] = t12;
    $[22] = t17;
    $[23] = t3;
    $[24] = t8;
    $[25] = t9;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t18 || $[28] !== t2) {
    t19 = <div className={t2}>{t18}</div>;
    $[27] = t18;
    $[28] = t2;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  return t19;
}